// Token names mostly identical to CPython https://github.com/python/cpython/blob/main/Lib/token.py.
// Main difference is that keywords are also a token type while in CPython they are generic name.
// We could also resolve special names at AST parse time.
// Also renamed some token names to make more sense.
export enum TokenType {
    //// Source S1
    ENDMARKER,
    NAME,
    NUMBER,
    STRING,
    NEWLINE,
    INDENT,
    DEDENT,
    LPAR,
    RPAR,
    COLON,
    DOUBLECOLON,
    COMMA,
    PLUS,
    MINUS,
    BANG,
    STAR,
    SLASH,
    VBAR,
    AMPER,
    LESS,
    GREATER,
    EQUAL,
    PERCENT,
    DOUBLEEQUAL,
    NOTEQUAL,
    LESSEQUAL,
    GREATEREQUAL,
    DOUBLESTAR,
    // Special identifiers
    AND,
    OR,
    FOR,
    WHILE,
    NONE,
    TRUE,
    FALSE,
    IS,
    NOT,
    ISNOT,
    PASS,
    DEF,
    LAMBDA,
    FROM,
    DOUBLESLASH,
    BREAK,
    CONTINUE,
    RETURN,
    ASSERT,
    IMPORT,
    GLOBAL,
    NONLOCAL,
    IF,
    ELSE,
    ELIF,
    IN,
    NOTIN,

    //// Source s3
    RSQB,
    LSQB,
    ELLIPSIS,

    //// Unusued - Found in normal Python
    SEMI,
    DOT,
    LBRACE,
    RBRACE,
    TILDE,
    CIRCUMFLEX,
    LEFTSHIFT,
    RIGHTSHIFT,
    PLUSEQUAL,
    MINEQUAL,
    STAREQUAL,
    SLASHEQUAL,
    PERCENTEQUAL,
    AMPEREQUAL,
    VBAREQUAL,
    CIRCUMFLEXEQUAL,
    LEFTSHIFTEQUAL,
    RIGHTSHIFTEQUAL,
    DOUBLESTAREQUAL,
    DOUBLESLASHEQUAL,
    AT,
    ATEQUAL,
    RARROW,
    COLONEQUAL,
    OP,
    AWAIT,
    ASYNC,
    TYPE_IGNORE,
    TYPE_COMMENT,
    YIELD,
    WITH,
    DEL,
    TRY,
    EXCEPT,
    FINALLY,
    RAISE,
}